function headerController(
    $scope,
    $transitions,
    PermissionService,
    DashboardConfig
) {
    var self = this;

    self.initialise = function () {
        $scope.productFruitsInitialised = false;

        // Fires when the user is initialised, or the context changed
        var userOrContextChange = function () {
            $scope.showSideBar = true;
            self.userContext = PermissionService.userContext;
            if (self.userContext) {
                $scope.contextType = self.userContext.getCurrentContextType();
                $scope.contextName = self.userContext.getCurrentContextName();
            }

            if (!$scope.productFruitsInitialised
                && PermissionService.user
                && DashboardConfig.ProductFruitsWorkspaceCode
                && typeof $productFruits !== 'undefined')
            {
                $productFruits.push([
                    'init',
                    DashboardConfig.ProductFruitsWorkspaceCode,
                    'en',
                    {
                        username: PermissionService.user.Email,
                        firstname: PermissionService.user.FirstName,
                        lastname: PermissionService.user.LastName,
                        props: {
                            domain: window.location.hostname
                        }
                    }
                ]);
                $scope.productFruitsInitialised = true;
            }
        };

        // This gets fired if the context changes
        $scope.$on(Dashboard.Events.UserContextChanged, function (event, success) {
            userOrContextChange(success);
        });

        $transitions.onSuccess({}, function(transition) {
            // don't run this logic if the from and to locations are the same
            if (transition.to().name === transition.from().name) {
                return;
            }

            userOrContextChange();
            $("body").removeClass("mini-navbar");
            SmoothlyMenu();
        });
    };

    /**
     * Toggles the nav menu into a minimized state
     */
    $scope.toggleNavMinimize = function () {
        $("body").toggleClass("mini-navbar");
        SmoothlyMenu();
    };

    $scope.navigateToHomePage = function() {
        var baseUrl = window.location.href.split('#')[0];
        window.location = baseUrl;
    }

    self.initialise();
}

angular
    .module('dashboard')
    .component('headerContainer',
    {
        templateUrl: 'components/header/header.7532999e.html',
        bindings: {},
        controller: [
            '$scope',
            '$transitions',
            'PermissionService',
            'DashboardConfig',
            headerController ]
    });
